


























import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'LogOutDialog',
})
export default class LogOutDialog extends Vue {
  dialog = false;

  async logout() {
    await this.$auth.logout({ returnTo: window.location.origin });
  }
}
